import { render, staticRenderFns } from "./DeviceCardTable.vue?vue&type=template&id=0470aa86&scoped=true"
import script from "./DeviceCardTable.vue?vue&type=script&lang=js"
export * from "./DeviceCardTable.vue?vue&type=script&lang=js"
import style0 from "./DeviceCardTable.vue?vue&type=style&index=0&id=0470aa86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0470aa86",
  null
  
)

export default component.exports